import { Box, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useState } from "react";

interface ImageSliderProps {
  imagePaths: string[];
  height?: string;
  width?: string;
}

const ImageSlider = ({ imagePaths, height = "400px", width = "100%" }: ImageSliderProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevImage = () => {
    setCurrentIndex((prev) => (prev === 0 ? imagePaths.length - 1 : prev - 1));
  };

  const nextImage = () => {
    setCurrentIndex((prev) => (prev === imagePaths.length - 1 ? 0 : prev + 1));
  };

  if (!imagePaths || imagePaths.length === 0) return null;

  return (<Box position="relative" width={width} height={height} overflow="hidden">
    <Box
      component="img"
      src={imagePaths[currentIndex]}
      alt={`slide-${currentIndex}`}
      sx={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        transition: "0.5s ease-in-out",
      }}
    />
    {imagePaths.length > 1 && (
      <>
        <IconButton
          onClick={prevImage}
          sx={{
            position: "absolute",
            top: "50%",
            left: "8px",
            transform: "translateY(-50%)",
            backgroundColor: "rgba(0,0,0,0.3)",
            color: "#fff",
            "&:hover": { backgroundColor: "rgba(0,0,0,0.5)" },
          }}
        > <ArrowBackIosNewIcon /> </IconButton>
        <IconButton
          onClick={nextImage}
          sx={{
            position: "absolute",
            top: "50%",
            right: "8px",
            transform: "translateY(-50%)",
            backgroundColor: "rgba(0,0,0,0.3)",
            color: "#fff",
            "&:hover": { backgroundColor: "rgba(0,0,0,0.5)" },
          }}
        > <ArrowForwardIosIcon /> </IconButton>
      </>
    )}
  </Box>
  );
};

export default ImageSlider;
